import { module } from 'modujs';
import { Swiper, Keyboard, Navigation, Autoplay } from 'swiper';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.items = this.$('item');
        this.images = this.$('image');

        if (this.el.classList.contains('is-tiny')) {
            this.initTinySwiper()
        } else {
            this.initSwiper()
        }
    }

    initSwiper() {
        Swiper.use([Keyboard, Autoplay]);

        this.container = this.$('container')[0]

        const args = {
            speed: 8000,
            loop: true,
            slidesPerView: 'auto',
            spaceBetween: 15,
            threshold: 3,
            centeredSlides: true,
            autoplay: {
                delay: 1,
                disableOnInteraction: false
            },
            keyboard: {
                enabled: true,
                onlyInViewport: false,
            },
            breakpoints: {
                699: {
                    slidesPerView: 'auto',
                    spaceBetween: 30
                }
            },
            on: {
                afterInit: () => {
                    this.call('update', null, 'Scroll')
                },
                click: (swiper) => {
                    this.currentIndex = swiper.clickedIndex;
                    this.initClickedSwiper();
                    this.call('open', null, 'Modal');
                }
            }
        }

        this.carousel = new Swiper(this.container, args);
    }

    initTinySwiper() {
        Swiper.use(Keyboard);

        this.container = this.$('container')[0]

        const args = {
            speed: 700,
            loop: false,
            slidesPerView: 'auto',
            spaceBetween: 10,
            threshold: 3,
            keyboard: {
                enabled: true,
                onlyInViewport: false,
            },
            on: {
                afterInit: () => {
                    this.call('update', null, 'Scroll')
                },
                click: (swiper) => {
                    this.currentIndex = swiper.clickedIndex;
                    this.initClickedSwiper();
                    this.call('open', null, 'Modal');
                }
            }
        }

        this.carousel = new Swiper(this.container, args);
    }

    initClickedSwiper() {
        this.arrowNext = document.querySelector('.c-modal #next');
        this.arrowPrev = document.querySelector('.c-modal #prev');

        Swiper.use([Keyboard, Navigation]);

        this.modal = document.querySelector('.c-modal .swiper-container');

        const params = {
            speed: 700,
            loop: true,
            slidesPerView: 'auto',
            spaceBetween: 0,
            threshold: 3,
            grabCursor: true,
            initialSlide: this.currentIndex,
            keyboard: {
                enabled: true,
                onlyInViewport: false,
            },
            navigation: {
                prevEl: this.arrowPrev,
                nextEl: this.arrowNext
            },
            on: {
                afterInit: () => {
                    this.call('update', null, 'Scroll')
                }
            }
        }

        this.clickedCarousel = new Swiper(this.modal, params)
    }

    destroyInitClickedSwiper() {
        if (this.clickedCarousel) this.clickedCarousel.destroy()
    }

    destroy() {
        if (this.carousel) this.carousel.destroy()
        if (this.clickedCarousel) this.clickedCarousel.destroy()
    }
}